module.exports = __webpack_public_path__ + "img/es-mb-s5.adb72e72.png";